const afb = {
	key: 'afb',
	name: 'Active&Fit Brands',
	getDesignTokens: mode => ({
		mode,
		primary: {
			main: '#702F8A',
			dark: '#612A80',
			light: '#FFEAFF',
			...(mode === 'dark' && {
				main: '#EFB0FF',
				dark: '#BB5AF2',
				light: '#FFEAFF',
			}),
		},
		secondary: {
			main: '#006497',
			dark: '#004B73',
			light: '#E7F2FF',
			...(mode === 'dark' && {
				main: '#CCE5FF',
				dark: '#91CDFF',
				light: '#CCE5FF',
			}),
		},
		tertiary: {
			main: '#FDD757',
			dark: '#E8C345',
			light: '#FFF0C3',
			...(mode === 'dark' && {
				main: '#FFF0C3',
				dark: '#E8C345',
				light: '#FDD757',
			}),
		},
	}),
};

export default afb;
